// This uses React's dangerouslySetInnerHTML to directly set the innerHTML of a span
// use carefully becuase the HTML is not sanitized for bad inputs, opening to XSS attacks
// See https://react.dev/reference/react-dom/components/common#dangerously-setting-the-inner-html
//
// Usage: .. <RawHTML>{add_HTML_string_here}</RawHTML>
//
// The code replaces \n with <br/>
export function RawHTML({ children, className = null }) {
  const html =
    typeof children === "string" ? children.replace(/\n/g, "<br />") : children
  return className ?
      <span className={className} dangerouslySetInnerHTML={{ __html: html }} />
    : <span dangerouslySetInnerHTML={{ __html: html }} />
}
